import HomePageComponent from './HomePage';
import ReigsterPageComponent from './registerPage';
import DashboardComponent from './dashboard';
import MemoriesComponent from './memories';
import EventsComponent from './events';
import SearchPartyComponent from './searchParty';
import TakeCareComponent from './takeCare';
import ProfileSettingsComponent from './profileSettings';
import CreateEventComponent from './createEvents';
import UploadPhotosComponent from './uploadPhotos';
import ReigsterPageTwoComponent from './registerTwo';

export {
  // eslint-disable-next-line import/prefer-default-export
  HomePageComponent, ReigsterPageComponent, DashboardComponent,
  EventsComponent, MemoriesComponent, SearchPartyComponent, TakeCareComponent,
  ProfileSettingsComponent, CreateEventComponent, UploadPhotosComponent, ReigsterPageTwoComponent,
};
